import React from "react";

import Alert from "@busbud/design-system-components/dist/Alert";
import type * as UDM from "@busbud/int-schemas/udm";

import { useAppContext } from "@app/helpers/hooks";
import type { CurrencyCode } from "@app/types/currency";

import { Money } from "../../lib/money";

const ONE_PLUS_TWO_SEATS_PER_ROW = 3;

type Props = {
  bus: UDM.Bus;
  currency: CurrencyCode;
  className?: string;
};

const ExpensiveSingleSeatBanner = (props: Props) => {
  const { translator, browser_locale } = useAppContext();
  const { bus, currency, className } = props;
  if (!_isOnePlusTwoLayout(bus)) {
    return null;
  }

  const price_difference = _getPriceDifference(bus);

  if (price_difference === 0) {
    return null;
  }

  const formatted_amount_with_currency = new Money(price_difference).getPrice(
    currency,
    browser_locale
  );

  const message = translator.t(
    "!seat-selection.single-seat-more-expensive-banner",
    {
      formatted_amount_with_currency
    }
  );
  return (
    <Alert severity="notice" className={className} size="sm">
      {message}
    </Alert>
  );
};

function _isOnePlusTwoLayout(bus: UDM.Bus) {
  if (!bus || !bus.layout || !bus.layout[0] || !bus.layout[0].cells[0]) {
    return false;
  }
  const first_row = bus.layout[0].cells[0];
  const total_seats_first_row = first_row.filter(
    seat => seat.type === "seat"
  ).length;
  return total_seats_first_row === ONE_PLUS_TWO_SEATS_PER_ROW ? true : false;
}

function _getPriceDifference(bus: UDM.Bus) {
  const FIRST_SEAT_INDEX = 0;
  const LAST_SEAT_INDEX = 4;
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const first_row = bus.layout![0].cells[0];
  const single_seat_prices =
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    first_row[FIRST_SEAT_INDEX].type === "seat" &&
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    first_row[FIRST_SEAT_INDEX].prices
      ? // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        first_row[FIRST_SEAT_INDEX].prices
      : [];
  const normal_seat_prices =
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    first_row[LAST_SEAT_INDEX].type === "seat" &&
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    first_row[LAST_SEAT_INDEX].prices
      ? // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        first_row[LAST_SEAT_INDEX].prices
      : [];

  if (!single_seat_prices.length) {
    return 0;
  }

  const category = single_seat_prices[0].category;

  const single_seat = single_seat_prices.find(
    _findSeatByCategory(category)
  ) || {
    base: 0
  };

  const normal_seat = normal_seat_prices.find(
    _findSeatByCategory(category)
  ) || {
    base: 0
  };

  return single_seat.base - normal_seat.base;
}

const _findSeatByCategory =
  (category: string) => (seat: UDM.SeatCellPassengerPrice) => {
    return seat.category === category ? seat : undefined;
  };

export default ExpensiveSingleSeatBanner;
